export const IMAGES = {
    AVATAR_DEFAULT: 'assets/images/avatars/user.png',
    LOGO: 'assets/images/Logo/logo.png',
    LOGO_DARK: "/assets/images/Logo/logo-dark.png",
    WHITE_BACKGROUND: '/assets/images/bg/white-bg.png',
    HEADER_BACKGROUND: '/assets/images/bg/getchkdbg.png',

    ICONS: {
        HOME: 'assets/icons/home.svg',
        SETTINGS: 'assets/icons/settings.svg',
    },
};
